import {CommonMessages} from '../common.messages';

export const DocumentsReportMessages = {
    GetDocumentsFailed: {
        key: 'GetDocumentsFailed',
        message: 'Error while communication with the server. Unable to load documents.'
    },
    ...CommonMessages
};

